import React, { FunctionComponent, ReactNode } from "react";
import { Box, type SxProps } from "@mui/material";

type MarginWrapperProps = {
  children: ReactNode;
  backgroundColor?: string;
  sx?: SxProps;
};

export const MarginWrapper: FunctionComponent<MarginWrapperProps> = ({
  children,
  backgroundColor = "#FFFFFF",
  sx,
}) => (
  <Box mx={3} my={2} sx={{ backgroundColor, ...sx }}>
    {children}
  </Box>
);
